export const START_EDIT_EVENT = 'START_EDIT_EVENT'

export const initialState = {
  trainingType: '',
  activeTraining: {},
  activity: '',
}

const eventReducer = (state = initialState, action) => {
  switch (action.type) {
    case START_EDIT_EVENT:
      return {
        ...state,
        activeTraining: action.training,
      }
    default:
      return state
  }
}

export const startEditEvent = (training) => {
  return {
    type: START_EDIT_EVENT,
    training,
  }
}

export default eventReducer
